import React from 'react';
import HeroSection from './HeroSection';
import SituacoesSection from './SituacoesSection';
import ConflitosSection from './ConflitosSection';
import CenariosSection from './CenariosSection';
import ComoFuncionaSection from './ComoFuncionaSection';
import ParaQuemSection from './ParaQuemSection';
import CtaFinalSection from './CtaFinalSection';
import FaqSection from './FaqSection';
import Footer from './Footer';

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-neutral-950">
      <main>
        <HeroSection />
        <SituacoesSection />
        <ConflitosSection />
        <CenariosSection />
        <ComoFuncionaSection />
        <ParaQuemSection />
        <CtaFinalSection />
        <FaqSection />
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;
